export const topupAmounts: number[] = [5, 10, 25, 50, 100];

export const minimumTopupEur = 5;
